/**
 * Thu nhỏ ảnh trước khi upload (TT 83 C1-c) — ảnh điện thoại 4–8 MB vượt giới hạn BE
 * (EKYC_MAX_IMAGE_BYTES = 5 MB) và tốn băng thông cho học viên ở nước ngoài.
 * Trình duyệt không hỗ trợ (jsdom, ảnh lỗi) → trả file gốc, BE vẫn chặn nếu quá cỡ.
 */
const MAX_EDGE = 1600;
const QUALITY = 0.85;

export async function downscaleImage(file: File): Promise<File> {
  if (typeof createImageBitmap !== "function" || typeof document === "undefined") return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    if (scale === 1 && file.size < 1.5 * 1024 * 1024) return file;
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const ctx = canvas.getContext("2d");
    if (!ctx) return file;
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", QUALITY),
    );
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}
